import { css, styled } from "styled-components";
import { PopupBtn } from "@template/components/Popup/styles.ts";
import {
  InputContentContainer,
  InputWrapper,
} from "@template/components/Input/styles.ts";

export const Domain = styled.div`
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.01em;
  width: 100%;

  > span {
    word-break: break-word;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    align-self: center;
    justify-self: center;
    width: fit-content;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > div > a {
    color: ${({ theme }) => theme.colors.default[600]};
    text-decoration: underline !important;
    font-size: 16px;
    font-weight: 600;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    justify-content: center;
    align-items: center;
  }

  > * {
    white-space: nowrap;
    ${({ theme }) => theme.breakpoints.md.query} {
      white-space: revert;
      width: 100%;
      text-align: center;
    }
  }
`;

export const Right = styled.div`
  display: flex;
  gap: 12px;
  height: fit-content;
  justify-content: flex-end;
  width: 100%;

  ${PopupBtn} {
    justify-content: flex-end;
    width: 100%;
    max-width: 320px;

    ${InputWrapper} {
      width: 100%;
      max-width: 320px;

      > div {
        max-width: revert;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  ${({ theme }) => theme.breakpoints.xs.query} {
    button {
      width: 100%;
    }
  }
`;

export const Premium = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  align-self: center;
  gap: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primary.default};
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.sm.query} {
    margin-right: revert;
    align-self: center !important;
  }
`;

export const Result = styled.div<{ $primary?: boolean }>`
  border-radius: 12px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  ${({ $primary }) =>
  $primary
    ? css`
          background: ${({ theme }) => theme.colors.default[50]};
          padding: 20px 24px 24px;

          ${Premium} {
            align-self: flex-start;
            background: ${({ theme }) => theme.colors.primary.default};
            padding: 4px 8px;
            color: ${({ theme }) => theme.colors.default[0]};
            border-radius: 4px;
          }

          ${Domain} {
            span {
              color: ${({ theme }) => theme.colors.primary.default};
            }
          }

          ${Left} {
            > * {
              text-align: left;
            }
          }
        `
    : css`
          padding: 12px 24px;

          ${Right} {
            ${PopupBtn} {
              max-width: max-content;

              ${InputWrapper} {
                max-width: max-content;

                > div {
                  max-width: revert;
                }

                ${InputContentContainer} {
                  color: ${({ theme }) => theme.colors.default.default};
                }
              }
            }
          }

          ${Domain} {
            font-size: 16px;
            font-weight: 550;
            color: ${({ theme }) => theme.colors.default[600]};

            strong {
              color: ${({ theme }) => theme.colors.default[900]};
              font-weight: 700;
            }
          }

          &:nth-of-type(even) {
            background: ${({ theme }) => theme.colors.default[50]};
          }
        `}
  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Promo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: flex-end;

  > svg {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;
